<key-video-list key-layout-grid-column-inner
    class="flex-1 list-view w-100 h-100"
    [showDateSelect]="false"
    [videos]="videoList"
    [selectedId]="asset.id"
    [listLoaded]="videoListLoaded"
    [count]="count"
    [page]="page"
    [showFilterByValue]="false"
    [noVideosMessage]="'SHARED.FEED.NO_RECENT.VIDEOS'"
    (pageChanged)="onPagedChanged($event)"
    (itemSelected)="onItemSelected($event)">
</key-video-list>